// Grid size limitations
export const GRID_WIDTH = 8;
export const GRID_HEIGHT = 15;

export const gridTileSize = 62;
export const gridMarginX = (480 - 8 * 62) / 2;
export const gridMarginY = (960 - 15 * 62) / 2;

// Strafe behavior constants
export const STRAFE_CHANCE = 0.15;
export const STRAFE_COOLDOWN_TICKS = 200;

// Battle replay timing
export const MS_PER_TICK = 16; // ~60 ticks per second
export const TICKS_PER_SECOND = 60; // For DoT calculations

// Realtime battle room: simulate at 60Hz, broadcast at a reduced rate.
// 4 ticks ≈ 15Hz — tune once playtest picks between the spec's 10-20Hz range.
export const BROADCAST_TICK_INTERVAL = 4;

// Overtime configuration — shared so the engine and every client playback
// path (live, replay, meta-balance tooling) agree on when overtime starts.
export const OVERTIME_START_TICK = 1800;
export const OVERTIME_DAMAGE_INTERVAL = 50;
export const OVERTIME_INITIAL_DAMAGE = 15;
